var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.20801 10.0002C2.20801 5.69694 5.69646 2.2085 9.99967 2.2085C14.3029 2.2085 17.7913 5.69694 17.7913 10.0002C17.7913 14.3034 14.3029 17.7918 9.99967 17.7918C5.69646 17.7918 2.20801 14.3034 2.20801 10.0002ZM9.99967 0.833496C4.93706 0.833496 0.833008 4.93755 0.833008 10.0002C0.833008 15.0627 4.93706 19.1668 9.99967 19.1668C15.0622 19.1668 19.1663 15.0627 19.1663 10.0002C19.1663 4.93755 15.0622 0.833496 9.99967 0.833496ZM9.99335 5.09441C9.94788 4.75897 9.66005 4.50016 9.31217 4.50016C8.93267 4.50016 8.62467 4.80816 8.62467 5.18766V10.6877L8.631 10.7809C8.67647 11.1164 8.9643 11.3752 9.31217 11.3752H12.9788L13.0721 11.3688C13.4076 11.3234 13.6663 11.0355 13.6663 10.6877C13.6663 10.3082 13.3583 10.0002 12.9788 10.0002H9.99967V5.18766L9.99335 5.09441Z",
    fill: "#64748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon);
export default __webpack_public_path__ + "static/media/schedule-icon.51e251b42eb39d63a2f49de490f6c3bf.svg";
export { ForwardRef as ReactComponent };